import { dcbNamesActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_NAME_DCB,
  FETCHING_NAME_DCB,
  FETCH_NAME_DCB_ERROR,
  FETCH_NAMES_DCB,
  FETCHING_NAMES_DCB,
  FETCH_NAMES_DCB_ERROR,
  FETCH_ATCCLASSIFICATION,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_NAME_DCB,
  DELETE_NAME_DCB,
  ADD_NAME_DCB,
  EDIT_NAME_DCB,
  FORM_TOUCHED,
  NEW_FORM_NAME_DCB,
  NAME_DCB_FORM_ERROR,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  RESET_STATE
} = dcbNamesActions

const initialState = {
  loadingNameDcb: false,
  loadingNamesDcb: false,
  fetchNameDcbError: false,
  fetchNamesDcbError: false,
  atcClassifications: [],
  namesDcb: [],
  order: {
    column: 'nome',
    direction: 1
  },
  nameDcb: {
    nome: '',
    numero_dcb: '',
    sinonimos: '',
    numero_cas: '',
    receita_tipo: '',
    classificacoesAtc: '',
    conteudos: ''
  },
  namesDcbPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  nameDcbFormErrors: {},
  nameDcbFormTouched: false,
  modalOpen: false
}

const nameDcbSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    },
    numero_dcb: {
      required: true
    },
    sinonimos: {
      required: false
    },
    numero_cas: {
      required: false
    },
    receita_tipo: {
      required: false
    },
    classificacoesAtc: {
      required: false
    },
    conteudos: {
      require: false
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    },
    numero_dcb: {
      required: true
    },
    sinonimos: {
      required: false
    },
    numero_cas: {
      required: false
    },
    receita_tipo: {
      required: false
    },
    classificacoesAtc: {
      required: false
    },
    conteudos: {
      require: false
    }
  }
}

const NameDcbValidate = new ValidateFormObject(nameDcbSchema)

const namesDcb = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case FETCH_ATCCLASSIFICATION:
      return {
        ...state,
        atcClassifications: action.atcClassifications
      }
    case CHANGE_NAME_DCB:
      formSchemaType = action.nameDcb._id ? 'edit' : 'add'
      return {
        ...state,
        nameDcb: action.nameDcb,
        nameDcbFormErrors: NameDcbValidate.validate({
          formObject: action.nameDcb,
          formSchemaType
        })
      }
    case NAME_DCB_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.nameDcb._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        nameDcbFormErrors: NameDcbValidate.validate({
          formObject: state.nameDcb,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_NAME_DCB:
      return {
        ...state,
        nameDcb: { ...initialState.nameDcb },
        nameDcbFormErrors: NameDcbValidate.validate({}),
        nameDcbFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        nameDcbFormTouched: true
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_NAME_DCB:
      formSchemaType = (action.nameDcb || {})._id ? 'edit' : 'add'
      return {
        ...state,
        nameDcb: action.nameDcb,
        loadingNameDcb: false,
        fetchNameDcbError: false,
        nameDcbFormTouched: false,
        nameDcbFormErrors: NameDcbValidate.validate({
          formObject: action.nameDcb,
          formSchemaType
        })
      }
    case FETCHING_NAME_DCB:
      return {
        ...state,
        loadingNameDcb: true,
        fetchNameDcbError: false
      }
    case DELETE_NAME_DCB:
      return {
        ...state,
        loadingNamesDcb: false,
        fetchNameDcbError: false,
        namesDcb: state.namesDcb.map(nameDcb => {
          if (nameDcb._id === action.nameDcb._id) {
            nameDcb = action.nameDcb
          }
          return nameDcb
        })
      }
    case FETCH_NAME_DCB_ERROR:
      return {
        ...state,
        loadingNameDcb: false,
        nameDcb: { ...initialState.nameDcb },
        fetchNameDcbError: action.error
      }
    case CHANGE_PAGE:
      return {
        ...state,
        namesDcbPagination: {
          ...state.namesDcbPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        namesDcbPagination: {
          ...state.namesDcbPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_NAMES_DCB:
      return {
        ...state,
        loadingNamesDcb: false,
        namesDcb: action.namesDcb,
        fetchNamesDcbError: false,
        order: action.order,
        namesDcbPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_NAME_DCB:
      return {
        ...state,
        namesDcb: state.namesDcb.map(nameDcb => {
          if (nameDcb._id === action.nameDcb._id) {
            return action.nameDcb
          }
          return nameDcb
        }),
        loadingNamesDcb: false,
        fetchNameDcbError: false,
        loadingNameDcb: false,
        fetchNamesDcbError: false
      }
    case FETCHING_NAMES_DCB:
      return {
        ...state,
        loadingNamesDcb: true,
        fetchNamesDcbError: false
      }
    case FETCH_NAMES_DCB_ERROR:
      return {
        ...state,
        loadingNamesDcb: false,
        fetchNameDcbError: action.error,
        loadingNameDcb: false
      }
    case ADD_NAME_DCB:
      return {
        ...state,
        loadingNamesDcb: false,
        fetchNameDcbError: false,
        loadingNameDcb: false,
        namesDcb: [...state.namesDcb, action.nameDcb]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default namesDcb



// WEBPACK FOOTER //
// ./src/reducers/dcbNames.js